// import theme from '@/components/styles';
import styled from 'styled-components';
import theme from '@/styles/theme';
import media from '@/styles/media';

interface ButtonProps {
  fillColor?: string;
  iconSrc?: string;
  fontColor?: string;
  borderColor?: string;
  size?: 'large' | 'medium' | 'small';
  fetching?: boolean;
  buttonWidth?: string;
}
const Button = styled.button.attrs({
  type: 'button',
})<ButtonProps>`
  border: none;     
  font-size: 14px;
  font-family: ${theme.fontFamily.regular};  
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .3s, color 1s;
  user-select: none;
  white-space: nowrap;
  
  color: #fff;
  box-shadow: 0px 3px 6px #00000029;
  transition: .2s;
  border-radius: 24px;
  padding: 14px 24px;
	display: flex;
	align-items: center;
	justify-content: center;
  cursor: pointer;

  ${media.lg`
     font-family: ${theme.fontFamily.semiBold}; 
  `}
  
  
  :not([disabled]):hover {
    filter: brightness(1.2);
  }

  ${({ fillColor }) => (fillColor ? `
    background-color: ${fillColor};
  ` : `
    background-color: ${theme.color.gray};
  `)}

${({ buttonWidth }) => (buttonWidth ? `
    width: 100%;
    max-width: ${buttonWidth};
  ` : `
    width: 100%;
    max-width: ${buttonWidth};
  `)}
  
  ${({ fontColor }) => (fontColor ? `color: ${fontColor};` : `color: ${theme.color.white};`)}
  ${({ borderColor }) => (borderColor ? `border: 2px solid ${borderColor};` : 'border: none;')}

  ${({ iconSrc }) => (iconSrc ? `
    ::before {
      content: url('${iconSrc}');
      width: 24px;
      height: 24px;
      margin-right: 12px;
    }
  ` : '')}

  
  ${({ size }) => {
    if (size === 'large') {
      return `
        height: 48px;
        padding: 14px 24px;
      `;
    }

    if (size === 'medium') {
      return `
        width: 130px;
        height: 48px;
        padding: 14px 24px;
      `;
    }

    if (size === 'small') {
      return `
        width: 80px;
        height: 36px;
        padding: 8px 24px;
      `;
    }

    return '';
  }}

  &[disabled] {
    opacity: .6;
    cursor: default;
  }
`;

export default Button;
